import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import config from '@/config';
import handleHttpError from '@/shared/services/HandleHttpError';
import { SettingsQueryKey } from './queryKey';
export var useGetDocumentSettings = function (enabled) {
    if (enabled === void 0) { enabled = true; }
    var intl = useIntl();
    return useQuery([SettingsQueryKey.DocumentSettings], function () {
        return api.base
            .get("".concat(config.appUrls.documents, "/api/settings/"))
            .then(function (res) { return res.data; });
    }, {
        enabled: enabled,
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    });
};
